import type { FeatureFlags } from '~/utils/featureFlags'

export interface User {
    id: string
    role: UserRole
    name: string
    email: string
    avatar?: string
    metadata?: { [key: string]: string }
    login_at?: string
    logout_at?: string
    updated_at: string
    features?: FeatureFlags
}

export enum UserRole {
    admin = 'admin',
    partner = 'partner',
    medicalDirector = 'medical_director',
    doctor = 'doctor',
    operator = 'operator',
    viewer = 'viewer',
    fieldMedic = 'field_medic',
    telemedicineAdmin = 'telemedicine_admin',
    telemedicineDoctor = 'telemedicine_doctor',
}
